module.exports = __webpack_public_path__ + "build/img/slimes_42.407fe4b0.png";